import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import { AllowFloats, handlePaste } from '../../CommonUtils/CommonValidations';

export default function FFcaFeeDuesUniversity() {
  const AfiliationFeeDueValidation = Yup.object({
    data: Yup.array().of(Yup.object().shape({
      feesPendingByCollege: Yup.string().required(ERROR_MSG).nullable(),
      ucsFeePending: Yup.string().required(ERROR_MSG).nullable(),
    })),
  })
  const AffflFeeDueFormik = useFormik({
    initialValues: {

      data: [{
        feeAccYear: "",
        feesPendingByCollege: "",
        ucsFeePending: "",

      }]
    },
    validationSchema: AfiliationFeeDueValidation,
    onSubmit: (values) => {
      values?.data.map(item => ({
        feeAccYear: item.feeAccYear,
        feesPendingByCollege: item.feesPendingByCollege || '',
        ucsFeePending: item.ucsFeePending || '',
        totalPendingFeeAmount: item.totalPendingFeeAmount || ''
      }),)


      Swal.fire({
        text: 'Are you sure you want to submit?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, submit it!',
        cancelButtonText: 'No, cancel!',
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const url = `${config.url.API_URL}saveFfcaFeeDetails`;

          CommonAxiosPost(url, values?.data).then((res) => {
            if (res?.data?.scode === '01') {
              successAlert2(res?.data?.sdesc);
              GetFeeData();
            } else {
              failureAlert(res?.data?.sdesc);
            }
          });
        } else {
          console.log('Submission canceled');
        }
      });

    },
  })

  const [feeData, setFeeData] = useState([]);

  function GetFeeData() {
    let url = config.url.API_URL + "getFfcaFeeData";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        setFeeData(res?.data?.FfcaFeeData)
        res?.data?.FfcaFeeData?.forEach((data, i) => {
          AffflFeeDueFormik?.setFieldValue(`data[${i}].feeAccYear`, data?.ac_yearr);
          AffflFeeDueFormik?.setFieldValue(`data[${i}].feesPendingByCollege`, data?.fees_pending_by_college);
          AffflFeeDueFormik?.setFieldValue(`data[${i}].ucsFeePending`, data?.ucs_fee_pending);
          AffflFeeDueFormik?.setFieldValue(`data[${i}].totalPendingFeeAmount`, data?.total_pending_fee_amount);

        })

      } else {
        setFeeData([])

      }
    })
  }
  useEffect(() => {
    GetFeeData();
  }, [])

  return (
    <>
      <CommonFormHeading heading="Affiliation Fee Pending Status Details" />
      <bie.Container fluid className="px-1" >

        <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
          <FormikProvider value={AffflFeeDueFormik}>
            <bie.Row className="px-2 pt-3 mb-3">
              <Form onChange={AffflFeeDueFormik.handleChange} onSubmit={AffflFeeDueFormik.handleSubmit} className='affl-form'>
                <bie.Alert variant='danger' className='affl-alert'>
                  <p className='mb-0' >Note: Affiliation Fee Pending details Need To Collect From Dean CDC.</p>
                </bie.Alert>
                <div className="table-responsive">
                  <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Academic Year	</th>
                        <th>Amount of Affiliation Fees pending
                          by the college to the University	</th>
                        <th>Amount of UCS Fee pending by the
                          college till the last academic year</th>
                        <th>Total Fee Pending</th>
                      </tr>

                    </thead>
                    <tbody>
                      {feeData?.map((course, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            {course?.ac_yearr}
                            <Field type="hidden" name={`data[${index}].feeAccYear`} />

                          </td>
                          <td className="cen">
                            <Field
                              type="text"
                              onKeyPress={(e) => { AllowFloats(e); }}
                              onPaste={(e) => handlePaste(e)}
                              className="form-control"
                              name={`data[${index}].feesPendingByCollege`}
                              maxLength={8}
                              onChange={(e) => {
                                const newTotFee = parseFloat(e.target.value) || 0;
                                AffflFeeDueFormik?.setFieldValue(`data[${index}].feesPendingByCollege`, newTotFee);
                                const feePaid = parseFloat(AffflFeeDueFormik?.values.data[index].ucsFeePending) || 0;
                                const sum = newTotFee + feePaid;
                                const roundedSum = Math.round(sum * 100) / 100;

                                AffflFeeDueFormik?.setFieldValue(`data[${index}].totalPendingFeeAmount`, roundedSum);
                              }}
                            />
                            <ErrorMessage name={`data[${index}].feesPendingByCollege`} component="div" className="text-error" />
                          </td>

                          <td className="cen">
                            <Field
                              type="text"
                              className="form-control"
                              name={`data[${index}].ucsFeePending`}
                              onKeyPress={(e) => { AllowFloats(e); }} onPaste={(e) => handlePaste(e)}
                              onChange={(e) => {
                                const newFeePaid = parseFloat(e.target.value) || 0;
                                AffflFeeDueFormik?.setFieldValue(`data[${index}].ucsFeePending`, newFeePaid);
                                const totFee = parseFloat(AffflFeeDueFormik?.values.data[index].feesPendingByCollege) || '';
                                const sum = totFee + newFeePaid;
                                const roundedSum = Math.round(sum * 100) / 100;
                                AffflFeeDueFormik?.setFieldValue(`data[${index}].totalPendingFeeAmount`, roundedSum);
                              }}
                            />
                            <ErrorMessage name={`data[${index}].ucsFeePending`} component="div" className="text-error" />
                          </td>

                          <td className="cen">
                            <Field type="text" className="form-control" name={`data[${index}].totalPendingFeeAmount`} disabled />
                          </td>
                        </tr>
                      ))}
                    </tbody>

                  </table>
                </div>
                <div className="button-cend pt-1 mb-4">
                  <button type='submit' className='btn btn-success btn-sm float-end rounded' >Submit</button>
                </div><br />
              </Form>
            </bie.Row>
          </FormikProvider>
        </bie.Container>
      </bie.Container>
    </>
  )
}

